import { render, staticRenderFns } from "./UseCardView.vue?vue&type=template&id=1be9f566&scoped=true"
import script from "./UseCardView.vue?vue&type=script&lang=js"
export * from "./UseCardView.vue?vue&type=script&lang=js"
import style0 from "./UseCardView.vue?vue&type=style&index=0&id=1be9f566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be9f566",
  null
  
)

export default component.exports